import { useMemo } from "react";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { Sidebar } from "../../../containers/Sidebar/Sidebar";
import useStyles from "./styles";
import { CustomTable } from "../../../components/CustomTable/CustomTable";
import { CustomButtonTable } from "../../../components/CustomButtonTable/CustomButtonTable";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getCurrentFleetId } from "../../../utils/getCurrentFleet";
import { CustomLoader } from "../../../components/CustomLoader/CustomLoader";
import { useCollaboratorRoster } from "../../../hooks/useCollaboratorRoster";
import { getColumnsCollaborator } from "./columnsCollaborator";

type Props = {};

export const ListCollaborator: React.FC<Props> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Keye sur `t` : les en-tetes se reconstruisent au changement de langue.
  const columns = useMemo(() => getColumnsCollaborator(t), [t]);

  /*
   * Confirmed members AND outstanding invitations. The list previously showed
   * only `company_user` rows, which do not exist until an invitee finishes
   * signing up - so an invited person was invisible, and there was no way to
   * tell "never invited" from "waiting" from "link expired after 72h".
   */
  const { rows, isPending, memberCount, pendingCount, expiredCount } =
    useCollaboratorRoster(getCurrentFleetId());

  return (
    <>
      {isPending && <CustomLoader isActive={isPending} />}
      <Sidebar
        styles={{
          sidebarRightRoot: classes.vehiculeRoot,
          sidebarRoot: classes.contentMain,
        }}
      >
        <div className={classes.containerHeader}>
          <CustomTypography
            variant="h2"
            text={t("collaborator.collaboratorList", "Collaborator list")}
            isUppercase
          />
          <CustomButtonTable
            variant={"primary"}
            textVariant={"link"}
            label={t("collaborator.addACollaborator", "Add a collaborator")}
            width={"fit-content"}
            fontWeight={"bold"}
            textDecoration={"none"}
            iconName={"plus"}
            padding={"0px 15px"}
            textTransform="uppercase"
            onClick={() => navigate("/collaborator/create")}
          />
        </div>

        {/* Counts make an expired invitation impossible to miss: it is the
            state that silently blocks onboarding and needs a resend. */}
        <div className={classes.rosterSummary}>
          <span>
            {t("collaborator.countMembers", "{{count}} collaborateur(s)", {
              count: memberCount,
            })}
          </span>
          {pendingCount > 0 && (
            <span className={classes.summaryPending}>
              {t("collaborator.countPending", "{{count}} en attente", {
                count: pendingCount,
              })}
            </span>
          )}
          {expiredCount > 0 && (
            <span className={classes.summaryExpired}>
              {t("collaborator.countExpired", "{{count}} expiree(s)", {
                count: expiredCount,
              })}
            </span>
          )}
        </div>

        <CustomTable columns={columns} data={rows} isSearchable />
      </Sidebar>
    </>
  );
};
